import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";

import styles from "./dynamicInputStyles.js";

import {
  PRIMARY,
  INFO,
  SUCCESS,
  WARNING,
  DANGER,
  ROSE,
} from "utils/colorsTheme";

const useStyles = makeStyles(styles);

function DynamicInput(props, ref) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    color,
    white,
    inputRootCustomClasses,

    helperText,
  } = props;

  const labelClasses = classNames({
    [" " + classes.labelRootError]: color === DANGER,
    [" " + classes.labelRootSuccess]: color === SUCCESS,
    [" " + classes.labelRootInfo]: color === INFO,
    [" " + classes.labelRootPrimary]: color === PRIMARY,
    [" " + classes.labelRootWarning]: color === WARNING,
    [" " + classes.labelRootRose]: color === ROSE,
  });
  const underlineClasses = classNames({
    [classes.underlineError]: color === DANGER,
    [classes.underlineSuccess]: color === SUCCESS,
    [classes.underlineInfo]: color === INFO,
    [classes.underlinePrimary]: color === PRIMARY,
    [classes.underlineWarning]: color === WARNING,
    [classes.underlineRose]: color === ROSE,
    [classes.underline]: true,
    [classes.whiteUnderline]: white,
  });
  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined,
  });
  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white,
  });
  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }
  var helpTextClasses = classNames({
    [classes.labelRootError]: color === DANGER,
    [classes.labelRootSuccess]: color === SUCCESS,
    [classes.labelRootInfo]: color === INFO,
    [classes.labelRootPrimary]: color === PRIMARY,
    [classes.labelRootWarning]: color === WARNING,
    [classes.labelRootRose]: color === ROSE,
  });
  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      {labelText !== undefined ? (
        <InputLabel
          className={classes.labelRoot + " " + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Input
        ref={ref}
        classes={{
          input: inputClasses,
          root: marginTop,
          disabled: classes.disabled,
          underline: underlineClasses,
        }}
        id={id}
        {...inputProps}
      />
      {helperText !== undefined ? (
        <FormHelperText id={id + "-text"} className={helpTextClasses}>
          {helperText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}

export default React.forwardRef(DynamicInput);
